import type { SanityLegalIndex } from '#/lib/sanity/queries/legalIndex';
import { Headline } from '#/components/Headline';
import { Link } from '#/components/Link';

export function LegalIndex({ page }: { page: SanityLegalIndex }) {
  return (
    <div className="p-main mb-80 pt-20 m:mb-130 m:pt-50">
      <div className="mx-auto mb-40 max-w-860 space-y-15 text-center m:mb-60">
        <Headline
          value={page.headline}
          as="h1"
          variant={1}
          className="leading-110"
        />
        {page.intro ? (
          <p className="mx-auto max-w-640 text-balance text-14 font-light leading-160 text-grayscale-06 m:text-16">
            {page.intro}
          </p>
        ) : null}
      </div>
      <ul className="mx-auto grid max-w-1235 grid-cols-1 gap-15 m:grid-cols-2 l:grid-cols-3 l:gap-17">
        {page.cards.map((card) => (
          <li key={card._key}>
            <Link
              href={card.href}
              target={
                card._type === 'externalCard' && card.newTab
                  ? '_blank'
                  : undefined
              }
              className="flex h-full flex-col justify-between gap-y-15 rounded-15 bg-grayscale-01 p-20 outline-none transition-colors hover:bg-grayscale-02 focus-visible:ring-1 focus-visible:ring-cipher m:rounded-25 m:p-25"
            >
              <div className="space-y-10">
                <Headline
                  value={card.title}
                  as="h2"
                  variant={6}
                  className="leading-120"
                />
                {card.caption ? (
                  <p className="text-14 font-light leading-154 text-grayscale-06 m:text-16">
                    {card.caption}
                  </p>
                ) : null}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
